export default ({ title, subTitle, style }) => {
  return (
    <div style={style}>
      <div
        style={{
          fontWeight: 600,
          fontSize: '18px',
          height: '25px',
          lineHeight: '25px',
          color: '#212121',
        }}
      >
        {title}
      </div>
      {subTitle && (
        <div
          style={{
            fontWeight: 400,
            fontSize: '12px',
            height: '17px',
            lineHeight: '17px',
            color: '#999999',
          }}
        >
          {subTitle}
        </div>
      )}
    </div>
  );
};
